/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { forwardRef, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Slider,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ModalTitle from "examples/NewDesign/ModalTitle";
import { useDispatch, useSelector } from "react-redux";
import style from "assets/style/Modal";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import uploadImageThunk from "redux/Thunks/ImageUpload";
import { openSnackbar } from "redux/Slice/Notification";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import pxToRem from "assets/theme/functions/pxToRem";
import Constants, { Icons, ButtonTitles, defaultData, Colors } from "utils/Constants";
import FormControlErrorStyles from "assets/style/Component";
import MDInput from "components/MDInput";
import FullScreenImageComponent from "components/ViewFullImage/ViewImage";
import { getAllSubmitterLoanFormThunk, submitLoanFormThunk } from "redux/Thunks/LoanFormConfig";
import { updateInquiryStatusThunk } from "redux/Thunks/Inquiry";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import "react-datepicker/dist/react-datepicker.css";
import { paramCreater } from "utils/methods/methods";
import Pdf from "assets/images/pdf.svg";

const optionalFields = [
  "panCardDocuments",
  "aadharCardDocuments",
  "salarySlipDocuments",
  "sixMonthsbankStatementDocuments",
  "homeElectricityBillDocuments",
  "twelveMonthsbankStatementDocuments",
  "itrDocuments",
  "officeElectricityBillDocuments",
  "msmeCertificateDocuments",
  "gstCertificateDocuments",
  "otherBusinessProofDocuments",
  "applicantPhotoDocuments",
  "loanSanctionLetterDocuments",
  "propertyDocuments",
  "newCarQuotationDocuments",
  "oldCarRcDocuments",
  "creditCardFrontDocuments",
];

function leadBayForm({
  screenIndex,
  cardType,
  open,
  setOpen,
  bgColor,
  handleReset,
  prefillData = null,
}) {
  const [form, setForm] = useState({});
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [fullScreenImageIndex, setFullScreenImageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState([]);
  const [leadBayBody, setLeadBayBody] = useState({});
  const [requiredList, setRequiredList] = useState([...optionalFields]);
  const ConfigData = useSelector((state) => state.loan);
  const dispatch = useDispatch();

  useEffect(() => {
    const tempForm = ConfigData.screens?.[screenIndex]?.screensInfo;
    if (!tempForm || !tempForm.properties || !Array.isArray(tempForm.properties)) return;
    const defaultValues = {};
    tempForm.properties.forEach((item) => {
      if (item.type === "boolean") {
        defaultValues[item.id] = false;
      } else if (item.default !== undefined && item.default !== null && item.default !== "") {
        defaultValues[item.id] = item.default;
      }
    });
    if (!defaultValues.leadDate) {
      defaultValues.leadDate = moment().format(defaultData.DATABSE_DATE_FORMAT);
    }
    defaultValues.dynamicFields = [];

    if (prefillData && typeof prefillData === "object") {
      Object.keys(prefillData).forEach((key) => {
        if (
          prefillData[key] !== undefined &&
          prefillData[key] !== null &&
          prefillData[key] !== ""
        ) {
          defaultValues[key] = prefillData[key];
        }
      });
      if (prefillData.leadDate) {
        defaultValues.leadDate = moment(prefillData.leadDate).format(
          defaultData.DATABSE_DATE_FORMAT
        );
      }
    }

    // If a prefilled field has dependent child fields (e.g. carLoanType), initialize child visibility
    const clonedForm = JSON.parse(JSON.stringify(tempForm));
    if (clonedForm?.properties && Array.isArray(clonedForm.properties)) {
      clonedForm.properties.forEach((prop) => {
        if (prop.hasChildField && defaultValues[prop.id]) {
          const selectedOption = prop.options?.find((opt) => opt.id === defaultValues[prop.id]);
          if (selectedOption?.dependentFieldIds?.length > 0) {
            clonedForm.properties.forEach((childItem, i) => {
              if (childItem.parentFieldId === prop.id) {
                if (selectedOption.dependentFieldIds.includes(childItem.id)) {
                  clonedForm.properties[i].isDefaultVisible = true;
                  if (childItem.type !== "document") clonedForm.properties[i].IsRequired = true;
                } else {
                  clonedForm.properties[i].isDefaultVisible = false;
                  clonedForm.properties[i].IsRequired = false;
                }
              }
            });
          }
        }
      });
    }

    setLeadBayBody(defaultValues);
    setForm(clonedForm);
  }, [ConfigData, screenIndex, prefillData]);

  useEffect(() => {
    if (form?.properties && Array.isArray(form.properties)) {
      form.properties.forEach((item) => {
        if (item.IsRequired) {
          setRequiredList((prev) => [...prev, item.id]);
        }
      });
    }
  }, [form]);

  const handleEditClose = () => {
    sessionStorage.removeItem("finvibes_active_inquiry_id");
    sessionStorage.removeItem("finvibes_active_inquiry_loan_type");
    setLeadBayBody([]);
    setErrors([]);
    setImage([]);
    setOpen(false);
  };
  const validate = () => {
    const newErrors = {};

    if (form?.properties && Array.isArray(form.properties)) {
      form.properties.forEach((item) => {
        if (
          item.IsRequired &&
          !item.questionId &&
          !leadBayBody[item.id] &&
          item.type !== "boolean"
        ) {
          newErrors[item.id] = `This field is required`;
        } else if (
          item.IsRequired &&
          item.questionId &&
          !leadBayBody?.dynamicFields?.filter((val) => val?.title.replace(/\s/g, "") === item.id)
            .length > 0
        ) {
          newErrors[item.id] = `This field is required`;
        }
        if (
          item.IsRequired &&
          !item.questionId &&
          typeof leadBayBody[item.id] === "string" &&
          leadBayBody[item.id]?.trim() === ""
        ) {
          newErrors[item.id] = "Empty Space is not allowed";
        }
        if (item.IsRequired && item.questionId) {
          const index = leadBayBody?.dynamicFields?.findIndex(
            (val) => val?.title.replace(/\s/g, "") === item.id
          );
          if (
            typeof leadBayBody?.dynamicFields?.[index]?.value[0] === "string" &&
            leadBayBody?.dynamicFields?.[index]?.value[0]?.trim() === ""
          ) {
            newErrors[item.id] = "Empty Space is not allowed";
          }
        }
      });
    }

    setErrors(newErrors);
    return Object.values(newErrors).filter((val) => val !== "").length === 0;
  };

  const updateFormField = (idArray = [], parentId) => {
    if (idArray.length > 0) {
      const temp = JSON.parse(JSON.stringify(form));
      const t = [];
      temp.properties.forEach((item, i) => {
        if (item.parentFieldId === parentId) {
          const index = idArray.findIndex((val) => val === item?.id);
          if (index !== -1) {
            temp.properties[i].isDefaultVisible = true;
            if (item.type !== "document") temp.properties[i].IsRequired = true;
            t.push(item);
          } else {
            temp.properties[i].isDefaultVisible = false;
            temp.properties[i].IsRequired = false;
          }
        }
      });
      setForm(temp);
    } else {
      setForm(ConfigData.screens?.[screenIndex].screensInfo);
    }
  };

  const getFieldMaxLength = (item) => item?.range?.max || null;

  const getLimitedFieldValue = (item, value) => {
    const maxLength = getFieldMaxLength(item);
    if (!maxLength) return value;

    if (item.type === "number" || item.type === "mobile") {
      return value.toString().replace(/\D/g, "").slice(0, maxLength);
    }

    return value.toString().slice(0, maxLength);
  };

  const handleNumericKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Home",
      "End",
    ];

    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;

    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const getMobileDisplayValue = (value = "") => (value.startsWith("+91") ? value.slice(3) : value);

  const formatNumberWithCommas = (val) => {
    if (val === undefined || val === null) return "";
    const clean = val.toString().replace(/,/g, "");
    if (clean === "") return "";
    const num = Number(clean);
    if (Number.isNaN(num)) return clean;
    return num.toLocaleString("en-IN");
  };

  const cleanNumberString = (val) => {
    if (val === undefined || val === null) return "";
    return val.toString().replace(/,/g, "");
  };

  const handleChange = (name, value, id) => {
    if (
      name === "loginDate" ||
      name === "dateOfLogin" ||
      id === "loginDate" ||
      id === "dateOfLogin"
    ) {
      if (value && moment(value).isAfter(moment(), "day")) {
        setErrors((prev) => ({ ...prev, [name]: "Login date cannot be a future date" }));
        return;
      }
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    const temp = leadBayBody;
    const isTopLevelField = name === id;

    if (!isTopLevelField) {
      const index = temp.dynamicFields.findIndex((val) => val.fieldId === id);
      if (index >= 0 && value !== "") {
        temp.dynamicFields[index].value = [value];
      } else if (index >= 0 && value === "") {
        temp.dynamicFields.splice(index, 1);
      } else {
        const dynamicFieldValueObject = {
          title: name,
          value: [value],
          fieldId: id,
        };
        temp.dynamicFields.push(dynamicFieldValueObject);
      }
    } else if (name in temp && value === "") {
      delete temp[name];
    } else {
      temp[name] = value;
    }
    form?.properties?.forEach((item) => {
      // remove child field when parent field is changed
      if (item?.parentFieldId === name) {
        delete temp?.[item?.id];
      }
    });

    setLeadBayBody({ ...temp });
  };

  const handleImageChange = (name, value, id) => {
    const temp = leadBayBody;
    const index = temp.dynamicFields.findIndex((val) => val.fieldId === id);
    if (!requiredList.includes(name)) {
      if (index >= 0 && value.length > 0) {
        temp.dynamicFields[index].value = value;
      } else if (index >= 0 && value.length === 0) {
        temp.dynamicFields.splice(index, 1);
      } else {
        const dynamicFieldValueObject = {
          title: name,
          value,
          fieldId: id,
        };
        temp.dynamicFields.push(dynamicFieldValueObject);
      }
    } else if (name in temp && value.length === 0) {
      delete temp[name];
    } else {
      temp[name] = value;
    }
    setLeadBayBody({ ...temp });
  };

  const handleBoolean = (name, id, value) => {
    const temp = leadBayBody;

    temp[name] = value;
    setLeadBayBody({ ...temp });
  };

  const handleCheckbox = (name, id, value, checked) => {
    const temp = leadBayBody;
    const index = temp.dynamicFields.findIndex((val) => val.fieldId === id);
    if (index >= 0 && checked) {
      temp.dynamicFields[index].value.push(value.toString());
    } else if (index >= 0 && !checked) {
      temp.dynamicFields[index].value = temp.dynamicFields[index].value.filter(
        (val) => val !== value.toString()
      );
    } else {
      const dynamicFieldValueObject = {
        title: name,
        value: [value.toString()],
        fieldId: id,
      };
      temp.dynamicFields.push(dynamicFieldValueObject);
    }
    temp[name] = value;
    setLeadBayBody({ ...temp });
  };

  const handleCreateLeadBay = async () => {
    setLoading(true);
    const val = validate();
    if (val) {
      const tempBody = { ...leadBayBody };
      Object.entries(tempBody).forEach(([key]) => {
        if (typeof tempBody[key] === "string") {
          tempBody[key] = tempBody[key].trim();
        }
      });
      if (!tempBody.leadDate) tempBody.leadDate = moment().format(defaultData.DATABSE_DATE_FORMAT);
      if (tempBody.loginDate) tempBody.dateOfLogin = tempBody.loginDate;
      if (
        (tempBody.loginDate && moment(tempBody.loginDate).isAfter(moment(), "day")) ||
        (tempBody.dateOfLogin && moment(tempBody.dateOfLogin).isAfter(moment(), "day"))
      ) {
        setErrors((prev) => ({
          ...prev,
          loginDate: "Login date cannot be a future date",
        }));
        setLoading(false);
        return;
      }
      const res = await dispatch(submitLoanFormThunk({ type: form.configType, body: tempBody }));
      if (res.payload.status === 200) {
        const storedInquiryId = sessionStorage.getItem("finvibes_active_inquiry_id");
        const storedLoanType = sessionStorage.getItem("finvibes_active_inquiry_loan_type");
        const linkedInquiryId =
          prefillData?.inquiryId ||
          prefillData?.inquiryMongoId ||
          leadBayBody?.inquiryId ||
          storedInquiryId;
        const linkedLoanType = form?.configType || prefillData?.loanType || storedLoanType;

        if (linkedInquiryId) {
          try {
            await dispatch(
              updateInquiryStatusThunk({
                id: linkedInquiryId,
                status: "processed",
                loanType: linkedLoanType,
              })
            );
          } catch (statusErr) {
            console.error("Failed to update inquiry status:", statusErr);
          }
          sessionStorage.removeItem("finvibes_active_inquiry_id");
          sessionStorage.removeItem("finvibes_active_inquiry_loan_type");
        }
        setOpen(false);
        setImage([]);
        handleReset();
        dispatch(
          openSnackbar({
            message: Constants.LOAN_FORM_SUBMIT_SUCCESS,
            notificationType: Constants.NOTIFICATION_SUCCESS,
          })
        );
        const paramData = {
          page: 0,
          perPage: defaultData.DATE_ON_SINGLE_API_CALL,
        };
        await dispatch(getAllSubmitterLoanFormThunk(paramCreater(paramData)));
      } else if (res.payload.status === 422) {
        const newErrors = {};
        res.payload.data.data.error.forEach((item) => {
          const [keys, values] = Object.entries(item)[0];
          newErrors[keys] = values;
        });
        setErrors(newErrors);
        dispatch(
          openSnackbar({
            message: res.payload.data.message,
            notificationType: Constants.NOTIFICATION_ERROR,
          })
        );
      }
    }
    setLoading(false);
  };

  const handleCancelClick = (index, name, id) => {
    const newImageArray = [...leadBayBody[id]];
    newImageArray.splice(index, 1);
    setLeadBayBody({ ...leadBayBody, [id]: newImageArray });
  };
  const handleFileChange = async (name, e, id, maxDocument, acceptedFormats = []) => {
    const allowedFormats =
      acceptedFormats.length > 0
        ? acceptedFormats
        : ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
    const allowedFormatMessage =
      acceptedFormats.length > 0
        ? "Only JPG, JPEG, and PNG formats are allowed."
        : "Only JPG, JPEG, PNG, and PDF formats are allowed.";
    if ((leadBayBody?.[id]?.length || 0) + e.target.files.length <= maxDocument) {
      const newImages = [];
      for (let i = 0; i < e.target.files.length; i += 1) {
        const file = e.target.files[i];
        if (!allowedFormats.includes(file.type)) {
          dispatch(
            openSnackbar({
              message: allowedFormatMessage,
              notificationType: "error",
            })
          );
          return;
        }
        const preview = URL.createObjectURL(file);
        newImages.push({ file, preview });
      }

      const type = "LeadBay";
      const uploadPromises = newImages.map((img) =>
        dispatch(
          uploadImageThunk({
            file: img.file,
            type,
            allowedMimeTypes: acceptedFormats.length > 0 ? acceptedFormats : undefined,
          })
        )
      );
      const responses = await Promise.all(uploadPromises);
      const newImageUrlArray = responses.map((response) => ({
        name: response.payload.data.fileName,
        url: response.payload.data.iconUrl,
      }));
      const previousImage = leadBayBody?.[id] || [];
      handleImageChange(name, [...previousImage, ...newImageUrlArray], id);
    } else {
      dispatch(
        openSnackbar({
          message: `You can only upload up to ${maxDocument} documents.`,
          notificationType: "error",
        })
      );
    }
  };
  const dropdownIcon = () => <KeyboardArrowDownIcon fontSize="medium" sx={{ color: "#667085" }} />;

  const CustomDateTimeInput = forwardRef(({ value, onClick, item }, ref) => {
    const isLoginDate =
      item?.id === "loginDate" ||
      item?.id === "dateOfLogin" ||
      item?.title?.toLowerCase()?.includes("login date");

    return (
      <MDInput
        error={Boolean(errors[item.id])}
        helperText={errors[item.id]}
        FormHelperTextProps={{
          sx: { marginLeft: 1, color: "red" },
        }}
        InputLabelProps={{
          shrink: true,
        }}
        placeholder={item.hint}
        value={value}
        sx={{ ml: 0, width: 400, mt: 1 }}
        onClick={onClick}
        ref={ref}
        onKeyDown={(e) => {
          if (isLoginDate) {
            e.preventDefault();
          }
        }}
        InputProps={{
          readOnly: isLoginDate,
          endAdornment: (
            <InputAdornment position="end">
              <CalendarTodayIcon style={{ cursor: "pointer" }} />
            </InputAdornment>
          ),
        }}
      />
    );
  });

  const handleImage = (id) => {
    document.getElementById(id).click();
  };

  const handleImageFullView = (id, imageUrl, i) => {
    setImage(leadBayBody[id]);
    setFullScreenImageIndex(i);
    setFullScreenImage(imageUrl);
  };
  const handleCloseFullView = () => {
    setFullScreenImage(null);
  };
  const handleNextImage = () => {
    setFullScreenImageIndex((prevIndex) => (prevIndex + 1) % image.length);
  };

  const handlePreviousImage = () => {
    setFullScreenImageIndex((prevIndex) => (prevIndex - 1 + image.length) % image.length);
  };

  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox sx={style}>
          <MDBox
            bgColor={bgColor}
            p={3}
            mb={3}
            display="flex"
            borderRadius="lg"
            alignItems="center"
            justifyContent="space-between"
            sx={{ borderBottomRightRadius: 0, borderBottomLeftRadius: 0, height: pxToRem(72) }}
          >
            <ModalTitle title={form.title} color="white" />

            <Icon
              sx={{ cursor: "pointer", color: "beige" }}
              fontSize="medium"
              onClick={handleEditClose}
            >
              {Icons.CROSS}
            </Icon>
          </MDBox>
          <MDBox
            px={2}
            py={0}
            sx={{
              maxHeight: 500,
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                width: "5px",
              },
              "::-webkit-scrollbar-thumb": {
                background: "gray",
              },
              scrollbarWidth: "thin",
              scrollbarColor: "gray transparent",
            }}
          >
            {form?.properties &&
              Array.isArray(form.properties) &&
              form.properties
                .slice()
                .filter((item) => item.isDefaultVisible)
                .sort((a, b) => a.fieldSortOrder - b.fieldSortOrder)
                .map((item, index) => (
                  <MDBox mb={1} mt={0} key={item?.id}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="start">
                      <MDTypography
                        mt={2}
                        ml={1}
                        id="modal-modal-description"
                        display="flex"
                        alignItems="center"
                        sx={{
                          textTransform: "capitalize",
                          fontSize: pxToRem(14),
                          fontWeight: 500,
                          color: "#344054",
                          width: "220px",
                        }}
                      >
                        {item.type !== "termsAndConditions" ? (
                          `${item.title} ${item.IsRequired ? "*" : ""}`
                        ) : (
                          <MDBox>
                            <MDTypography
                              variant="caption"
                              sx={{ fontSize: pxToRem(14), fontWeight: 500, color: "#344054" }}
                            >
                              I have read and agree to the terms and conditions
                            </MDTypography>
                            <Tooltip title={item.title}>
                              <IconButton
                                sx={{ padding: 0, marginLeft: 0, marginTop: 1 }}
                                onClick={() => handleImage(item.id)}
                              >
                                {Icons.INFO}
                              </IconButton>
                            </Tooltip>
                          </MDBox>
                        )}
                      </MDTypography>

                      {item.type === "text" || item.type === "email" ? (
                        <MDInput
                          sx={{
                            width: 400,
                            mt: 1,
                            mr: 2,
                            "& input": {
                              fontSize: "16px",
                              color: "#667085",
                            },
                          }}
                          size="small"
                          variant="outlined"
                          placeholder={`Please Enter ${item.title}`}
                          id={item.id}
                          name={item.id}
                          error={Boolean(errors[item.id])}
                          helperText={errors[item.id]}
                          value={
                            leadBayBody?.[item.id] ||
                            leadBayBody?.dynamicFields.filter(
                              (val) => val?.fieldId === item?.questionId
                            )[0]?.value ||
                            ""
                          }
                          FormHelperTextProps={{
                            sx: { marginLeft: 0, marginTop: 1, color: "red" },
                          }}
                          onChange={(e) =>
                            handleChange(
                              item.id,
                              getLimitedFieldValue(item, e.target.value),
                              item.questionId ? item.questionId : item.id
                            )
                          }
                        />
                      ) : null}

                      {item.type === "dropdown" && item.parentFieldId === "" ? (
                        <FormControl
                          sx={{
                            mr: 2,
                            mt: 1,
                            minWidth: 120,
                            width: 400,
                            ...FormControlErrorStyles,
                          }}
                          error={Boolean(errors[item.id])}
                        >
                          <InputLabel id={item.id}>{item.hint}</InputLabel>
                          <Select
                            width="90%"
                            onChange={(e) => {
                              if (item.hasChildField) {
                                const val = item.options.findIndex(
                                  (opt) => opt.id === e.target.value
                                );
                                if (val !== -1) {
                                  updateFormField(item?.options[val]?.dependentFieldIds, item.id);
                                }
                              }
                              handleChange(
                                item.id,
                                e.target.value,
                                item.questionId ? item.questionId : item.id
                              );
                            }}
                            IconComponent={dropdownIcon}
                            labelId={item.id}
                            label={item.hint}
                            id={item.questionId ? item.questionId : item.id}
                            name={item.id}
                            sx={{
                              color: "#667085",
                              backgroundColor: "black",
                              paddingY: "0.5rem",
                              paddingX: "0.5rem",
                              fontSize: pxToRem(16),
                              fontWeight: 400,
                            }}
                            renderValue={(selected) => {
                              const val = item.options.filter(
                                (opt) => opt.id === selected || opt.id === selected[0]
                              )[0];
                              return (
                                <MDBox sx={{ display: "flex", alignItems: "center" }}>
                                  {val?.color && val?.color !== "" ? (
                                    <Box
                                      component="span"
                                      sx={{
                                        backgroundColor: `#${val?.color}`,
                                        borderRadius: "50%",
                                        width: "10px",
                                        height: "10px",
                                        mr: 1,
                                      }}
                                    />
                                  ) : null}
                                  <MDTypography
                                    variant="caption"
                                    sx={{ textTransform: "capitalize" }}
                                  >
                                    {val?.title}
                                  </MDTypography>
                                </MDBox>
                              );
                            }}
                            value={
                              leadBayBody[item.id] ||
                              leadBayBody?.dynamicFields.filter(
                                (val) => val?.fieldId === item?.questionId
                              )[0]?.value ||
                              ""
                            }
                            MenuProps={{
                              anchorOrigin: {
                                vertical: 32,
                                horizontal: -8,
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              PaperProps: {
                                style: {
                                  maxHeight: 200,
                                  opacity: 1,
                                  transform: "none",
                                  minWidth: "400px",
                                },
                              },
                            }}
                          >
                            <MenuItem disabled value="">
                              {item.hint}
                            </MenuItem>
                            {item.options.map((val) => (
                              <MenuItem
                                value={val?.id}
                                id={val?.id}
                                sx={{ display: "flex" }}
                                key={val?.id}
                              >
                                {val?.color && val?.color !== "" ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      backgroundColor: `#${val?.color}`,
                                      borderRadius: "50%",
                                      width: "10px",
                                      height: "10px",
                                      mr: 1,
                                    }}
                                  />
                                ) : null}
                                <MDTypography
                                  id={val?.id}
                                  variant="caption"
                                  sx={{
                                    textTransform: "capitalize",
                                    fontSize: pxToRem(16),
                                    fontWeight: 400,
                                    color: "#667085",
                                    display: "flex",
                                  }}
                                >
                                  {val?.title}
                                </MDTypography>
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText sx={{ marginLeft: 0 }}>{errors[item.id]}</FormHelperText>
                        </FormControl>
                      ) : null}

                      {(item.type === "dropdown" || item.type === "autocomplete") &&
                        item.parentFieldId !== "" &&
                        (() => {
                          const parentField = form?.properties?.find(
                            (val) => val.id === item.parentFieldId
                          );
                          const type = parentField?.options.find(
                            (element) => element.id === leadBayBody[item.parentFieldId]
                          )?.isDefault;

                          const selectedValue = item.options.find(
                            (val) => val.id === leadBayBody[item.id]
                          );
                          const currentValue =
                            typeof selectedValue === "object"
                              ? selectedValue?.title || selectedValue
                              : selectedValue || "";
                          const options =
                            (type
                              ? item.options
                                  .filter((val) => val?.isDefault)
                                  .map((val) => val?.title || "")
                              : item.options
                                  .filter((val) =>
                                    val.isVisibleForOptions.includes(
                                      leadBayBody[item.parentFieldId]
                                    )
                                  )
                                  .map((val) => val?.title || "")) || [];

                          return (
                            <Autocomplete
                              onChange={(e, value) => {
                                const selectecteValue = item.options.filter(
                                  (val) => val?.title === value
                                );
                                handleChange(
                                  item.id,
                                  selectecteValue.length > 0 ? selectecteValue[0]?.id : value,
                                  item.questionId || item.id
                                );
                              }}
                              freeSolo={type}
                              value={currentValue}
                              options={options}
                              sx={{
                                width: 400,
                                mt: 1,
                                mr: 2,
                                "& .MuiAutocomplete-inputRoot": {
                                  padding: "4px",
                                },
                              }}
                              popupIcon={
                                <KeyboardArrowDownIcon
                                  fontSize="medium"
                                  sx={{ color: "#667085" }}
                                />
                              }
                              renderInput={(params) => (
                                <MDInput
                                  {...params}
                                  label={item.hint}
                                  error={Boolean(errors[item.id])}
                                  helperText={errors[item.id]}
                                  FormHelperTextProps={{
                                    sx: { marginLeft: 0, marginTop: 1, color: "red" },
                                  }}
                                  onChange={(e) =>
                                    handleChange(
                                      item.id,
                                      e.target.value,
                                      item.questionId || item.id
                                    )
                                  }
                                  sx={{
                                    minWidth: 120,
                                    width: 400,
                                    ...FormControlErrorStyles,
                                  }}
                                />
                              )}
                              PaperProps={{
                                style: {
                                  maxHeight: 200,
                                },
                              }}
                            />
                          );
                        })()}
                      {item.type === "boolean" || item.type === "termsAndConditions" ? (
                        <MDBox
                          sx={{ width: 400, mt: 1, mr: 3.2 }}
                          display="flex"
                          justifyContent="start"
                          flexDirection="column"
                        >
                          <Switch
                            color="warning"
                            sx={{
                              "&.Mui-checked": {
                                color: "#fff",
                                backgroundColor: "#FF8E53",
                              },
                            }}
                            onChange={(e) =>
                              handleBoolean(item.id, item.questionId, e.target.checked)
                            }
                            error={Boolean(errors[item.id])}
                          />
                          <FormHelperText sx={{ marginLeft: 0, color: "#FF2E2E" }}>
                            {errors[item.id]}
                          </FormHelperText>
                        </MDBox>
                      ) : null}

                      {item.type === "checkbox" ? (
                        <MDBox sx={{ width: 400, mr: 2 }} display="flex" justifyContent="start">
                          <FormGroup error={Boolean(errors[item.id])}>
                            {item.options.map((val) => (
                              <FormControlLabel
                                key={val.id}
                                control={
                                  <Checkbox
                                    onChange={(e) =>
                                      handleCheckbox(
                                        item.title,
                                        item.questionId,
                                        val.title,
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                                label={val.title}
                              />
                            ))}
                            <FormHelperText sx={{ marginLeft: 0, color: "#FF2E2E" }}>
                              {errors[item.id]}
                            </FormHelperText>
                          </FormGroup>
                        </MDBox>
                      ) : null}

                      {item.type === "datetime" ? (
                        <MDBox
                          sx={{ width: 400, mr: 2, zIndex: 1000 - index }}
                          display="flex"
                          justifyContent="start"
                        >
                          <ReactDatePicker
                            selected={
                              (leadBayBody?.[item.id] &&
                                moment(leadBayBody?.[item.id]?.split(".")[0]).toDate()) ||
                              (leadBayBody?.dynamicFields?.filter(
                                (val) => val?.fieldId === item?.questionId
                              ).length > 0 &&
                                moment(
                                  leadBayBody?.dynamicFields?.filter(
                                    (val) => val?.fieldId === item?.questionId
                                  )?.[0]?.value[0]
                                ).toDate()) ||
                              ""
                            }
                            onChange={(date) => {
                              if (
                                (item.id === "loginDate" ||
                                  item.id === "dateOfLogin" ||
                                  item.title?.toLowerCase()?.includes("login date")) &&
                                date &&
                                moment(date).isAfter(moment(), "day")
                              ) {
                                return;
                              }
                              handleChange(
                                item.id,
                                moment(date)
                                  .format(defaultData.DATABASE_24_HOURS_FORMAT)
                                  .toString(),
                                item.questionId ? item.questionId : item.id
                              );
                            }}
                            customInput={<CustomDateTimeInput item={item} />}
                            showTimeSelect
                            dateFormat={defaultData.REACTDATETIMEPICKER_24_HOURS_FORMAT}
                            timeIntervals={5}
                            timeFormat="HH:mm"
                            maxDate={
                              item.id === "loginDate" ||
                              item.id === "dateOfLogin" ||
                              item.title?.toLowerCase()?.includes("login date")
                                ? new Date()
                                : undefined
                            }
                            filterDate={
                              item.id === "loginDate" ||
                              item.id === "dateOfLogin" ||
                              item.title?.toLowerCase()?.includes("login date")
                                ? (date) => date <= new Date()
                                : undefined
                            }
                          />
                        </MDBox>
                      ) : null}
                      {item.type === "number" ? (
                        <MDBox
                          sx={{ width: 400, mr: 2, mt: 1 }}
                          display="flex"
                          justifyContent="start"
                        >
                          <MDInput
                            sx={{
                              width: 400,
                            }}
                            type="text"
                            placeholder={`Please Enter ${item.title.toUpperCase()}`}
                            id={item.id}
                            name={item.id}
                            error={Boolean(errors[item.id])}
                            helperText={errors[item.id]}
                            value={(() => {
                              const rawVal =
                                leadBayBody?.[item.id] !== undefined
                                  ? leadBayBody[item.id]
                                  : leadBayBody?.dynamicFields?.find(
                                      (val) => val?.fieldId === item?.questionId
                                    )?.value?.[0] || "";
                              const isPincode =
                                item.id?.toLowerCase().includes("pin") ||
                                item.id?.toLowerCase().includes("zip") ||
                                item.title?.toLowerCase().includes("pin") ||
                                item.title?.toLowerCase().includes("zip");
                              return isPincode ? rawVal : formatNumberWithCommas(rawVal);
                            })()}
                            FormHelperTextProps={{
                              sx: { marginLeft: 0, color: "red" },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => {
                              const cleanVal = cleanNumberString(e.target.value);
                              const limitedVal = getLimitedFieldValue(item, cleanVal);
                              handleChange(
                                item.id,
                                limitedVal,
                                item.questionId ? item.questionId : item.id
                              );
                            }}
                          />
                        </MDBox>
                      ) : null}

                      {item.type === "mobile" ? (
                        <MDBox
                          sx={{ width: 400, mr: 2, mt: 1 }}
                          display="flex"
                          justifyContent="start"
                        >
                          <MDInput
                            sx={{
                              width: 400,
                            }}
                            type="text"
                            placeholder={`Please Enter ${item.title.toUpperCase()}`}
                            id={item.id}
                            name={item.id}
                            error={Boolean(errors[item.id])}
                            helperText={errors[item.id]}
                            value={getMobileDisplayValue(leadBayBody[item.id] || "")}
                            FormHelperTextProps={{
                              sx: { marginLeft: 0, color: "red" },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                              inputProps: {
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                                maxLength: getFieldMaxLength(item) || undefined,
                              },
                            }}
                            onKeyDown={handleNumericKeyDown}
                            onChange={(e) => {
                              handleChange(
                                item.id,
                                getLimitedFieldValue(item, e.target.value),
                                item.questionId ? item.questionId : item.id
                              );
                            }}
                          />
                        </MDBox>
                      ) : null}

                      {item.type === "slider" ? (
                        <MDBox
                          sx={{ width: 400, mr: 2, mt: 1 }}
                          display="flex"
                          justifyContent="start"
                          flexDirection="column"
                        >
                          <Slider
                            id={item.id}
                            name={item.id}
                            aria-label="Default"
                            valueLabelDisplay="auto"
                            min={item?.range?.min}
                            max={item?.range?.max}
                            step={2}
                            onChange={(e) =>
                              handleChange(
                                item.id,
                                e.target.value,
                                item.questionId ? item.questionId : item.id
                              )
                            }
                          />
                          <FormHelperText sx={{ marginLeft: 0, color: "#FF2E2E" }}>
                            {errors[item.id]}
                          </FormHelperText>
                        </MDBox>
                      ) : null}
                      {item.type === "date" ? (
                        <MDBox
                          sx={{ width: 400, mr: 2, zIndex: 1000 - index }}
                          display="flex"
                          justifyContent="start"
                        >
                          <ReactDatePicker
                            showYearDropdown
                            showMonthDropdown
                            selected={
                              (leadBayBody?.[item.id] && moment(leadBayBody?.[item.id]).toDate()) ||
                              (leadBayBody?.dynamicFields?.filter(
                                (val) => val?.fieldId === item?.questionId
                              ).length > 0 &&
                                moment(
                                  leadBayBody?.dynamicFields?.filter(
                                    (val) => val?.fieldId === item?.questionId
                                  )?.[0]?.value[0]
                                ).toDate()) ||
                              ""
                            }
                            onChange={(date) => {
                              if (
                                (item.id === "loginDate" ||
                                  item.id === "dateOfLogin" ||
                                  item.title?.toLowerCase()?.includes("login date")) &&
                                date &&
                                moment(date).isAfter(moment(), "day")
                              ) {
                                return;
                              }
                              handleChange(
                                item.id,
                                moment(date).format(defaultData.DATABSE_DATE_FORMAT).toString(),
                                item.questionId ? item.questionId : item.id
                              );
                            }}
                            customInput={<CustomDateTimeInput item={item} />}
                            dateFormat={defaultData.REACTDATETIMEPICKER_DATE_FORMAT}
                            timeIntervals={5}
                            dropdownMode="select"
                            maxDate={
                              item.id === "loginDate" ||
                              item.id === "dateOfLogin" ||
                              item.title?.toLowerCase()?.includes("login date")
                                ? new Date()
                                : undefined
                            }
                            filterDate={
                              item.id === "loginDate" ||
                              item.id === "dateOfLogin" ||
                              item.title?.toLowerCase()?.includes("login date")
                                ? (date) => date <= new Date()
                                : undefined
                            }
                          />
                        </MDBox>
                      ) : null}
                    </MDBox>
                    {item.type === "textarea" ? (
                      <MDBox>
                        <MDInput
                          sx={{
                            mt: 0,
                            width: 642,
                            ml: 1,
                            "& .MuiInputBase-input": {
                              fontSize: "16px",
                              fontWeight: 400,
                              color: "#667085",
                            },
                          }}
                          multiline
                          autoComplete="off"
                          inputProps={{
                            style: { textTransform: "capitalize", flex: "1", minHeight: "4em" },
                          }}
                          id={item.id}
                          name={item.id}
                          error={Boolean(errors[item.id])}
                          helperText={errors[item.id]}
                          FormHelperTextProps={{
                            sx: { marginLeft: 0 },
                          }}
                          value={leadBayBody[item.id]}
                          placeholder={`Please Enter ${item.title}`}
                          onChange={(e) =>
                            handleChange(
                              item.id,
                              e.target.value.substring(0, 3000),
                              item.questionId ? item.questionId : item.id
                            )
                          }
                        />
                        <MDTypography
                          sx={{
                            color: "#667085",
                            fontSize: "10px",
                            display: "flex",
                            justifyContent: "end",
                            mr: "25px",
                          }}
                        >
                          {leadBayBody?.[item.id]
                            ? `${leadBayBody?.[item.id].length}/3000`
                            : `0/3000`}
                        </MDTypography>
                      </MDBox>
                    ) : null}
                    {item.type === "document" ? (
                      <MDBox
                        display="flex"
                        flexDirection="row"
                        justifyContent="flex-start"
                        my={1}
                        mr={2}
                        ml={1}
                        sx={{ width: 642 }}
                      >
                        <MDBox display="flex" flexWrap="wrap">
                          {leadBayBody?.[item.id]?.map((img, i) => (
                            <MDBox
                              display="flex"
                              borderRadius="8px"
                              position="relative"
                              key={img.url}
                              mr={2}
                              mb={2}
                              sx={{ "&:hover .overlay": { display: "flex", borderRadius: "8px" } }}
                            >
                              <img
                                src={img.name.includes(".pdf") ? Pdf : img.url}
                                alt="Preview"
                                width={70}
                                height={70}
                                style={{ borderRadius: "8px" }}
                              />
                              <Box
                                display="none"
                                position="absolute"
                                top={0}
                                right={0}
                                bottom={0}
                                left={0}
                                alignItems="center"
                                justifyContent="center"
                                bgcolor="rgba(0, 0, 0, 0.5)"
                                className="overlay"
                              >
                                <Icon
                                  sx={{ color: "white", width: 30, height: 30, cursor: "pointer" }}
                                  onClick={() => handleImageFullView(item.id, img?.url || img, i)}
                                >
                                  {Icons.VIEW2}
                                </Icon>
                              </Box>
                              <Box
                                display="none"
                                position="absolute"
                                top={0}
                                right={0}
                                bottom={60}
                                left={70}
                                alignItems="center"
                                justifyContent="center"
                                bgcolor="rgba(0, 0, 0, 0.5)"
                                className="overlay"
                              >
                                <Icon
                                  sx={{ color: "white", width: 30, height: 30, cursor: "pointer" }}
                                  onClick={() =>
                                    handleCancelClick(
                                      i,
                                      item.id,
                                      item.questionId ? item.questionId : item.id
                                    )
                                  }
                                >
                                  {Icons.CROSS2}
                                </Icon>
                              </Box>
                            </MDBox>
                          ))}
                          {(leadBayBody[item.id]?.length || 0) < item.maxDocument && (
                            <MDBox
                              width={pxToRem(70)}
                              height={70}
                              borderRadius="lg"
                              sx={{
                                border: "2px dashed #D0D5DD",
                                borderRadius: "8px",
                                cursor: "pointer",
                                justifyContent: "center",
                                alignItems: "center",
                                display:
                                  (leadBayBody?.[item.id]?.length || 0) < item.maxDocument
                                    ? "flex"
                                    : "none",
                              }}
                              onClick={() => handleImage(item.id)}
                            >
                              {Icons.ADD}
                            </MDBox>
                          )}

                          <TextField
                            id={item.id}
                            sx={{
                              display: "none",
                            }}
                            size="small"
                            variant="outlined"
                            placeholder="Please Enter"
                            type="file"
                            inputProps={{
                              multiple: true,
                              accept: item.acceptedFormats?.join(",") || "image/*,application/pdf",
                            }}
                            onChange={(e) =>
                              handleFileChange(
                                item.id,
                                e,
                                item.questionId ? item.questionId : item.id,
                                item.maxDocument,
                                item.acceptedFormats
                              )
                            }
                          />
                        </MDBox>
                      </MDBox>
                    ) : null}
                  </MDBox>
                ))}

            <MDBox px={1} mb={2} mt={1} sx={{ float: "right" }}>
              <MDButton
                variant="contained"
                color={
                  (cardType === "Safe" && "success") ||
                  (cardType === "Unsafe" && "unsafe") ||
                  ((cardType === "Ncr" || cardType === "Incident") && "info")
                }
                onClick={handleCreateLeadBay}
                style={{
                  textTransform: "none",
                  boxShadow: "none",
                  background: Colors.PRIMARY,
                  color: Colors.WHITE,
                }}
              >
                {loading ? ButtonTitles.SUBMIT_LOADING : ButtonTitles.SUBMIT}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Modal>
      <FullScreenImageComponent
        fullScreenImage={fullScreenImage}
        handleCloseFullView={handleCloseFullView}
        handlePreviousImage={handlePreviousImage}
        handleNextImage={handleNextImage}
        image={image}
        src={image[fullScreenImageIndex]?.url}
      />
    </>
  );
}

export default leadBayForm;
